/**
 * faq-accordion.js
 * FAQ のアコーディオン開閉
 *
 * 【仕様】
 * - .js-faq-item が存在しないページでは何もしない
 * - .js-faq-trigger をクリックすると対象アイテムに is-open を付与してパネルを開く
 * - 他のアイテムはすべて is-open を除去して閉じる（同時に複数開かない）
 * - 開いているアイテムのトリガーを再度クリックすると閉じる
 *
 * 【使い方】
 * initFaqAccordion();
 *
 * 【マークアップ例】
 * <div class="js-faq-item">
 *   <button class="js-faq-trigger">質問テキスト</button>
 *   <div class="p-faq__answer">回答テキスト</div>
 * </div>
 */

export function initFaqAccordion() {
  const items = document.querySelectorAll('.js-faq-item');
  if (!items.length) return;

  items.forEach((item) => {
    const trigger = item.querySelector('.js-faq-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach((other) => other.classList.remove('is-open'));

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
}
